import { api } from "../../api";

const service = process.env.REACT_APP_BACKEND_WORKFLOW_URL;

export const dashboard_api = api(service);

const dashboard = () => {
  return {
    CheckCurrentSLA: async function (email) {
      return dashboard_api.get(`/approvals/email/CheckCurrentSLA`, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          email,
        },
      });
    },
  };
};

export const DashboardServices = {
  dashboard: dashboard,
};
